import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { GridComponent, PageService, SortService, FilterService, ResizeService, FreezeService, FilterSettingsModel, RowDataBoundEventArgs, RecordClickEventArgs } from '@syncfusion/ej2-angular-grids';
import { PaymentResponseDto } from '../shared/models/paymentResponseDto';
import { AttachmentData, RequestDocAttachmentResponse } from '../shared/models/requestDocAttachment';
import { RequestsService } from '../shared/services/requests.service';
import { MatDialog } from '@angular/material/dialog';
import { ViewPaymentRequestComponent } from '../view-payment-request/view-payment-request.component';
import { ExpectFundResponseDto } from '../shared/models/expectResponseDto';
import { ViewExpectFundComponent } from '../view-expect-fund/view-expect-fund.component';
import { SnackbarService } from '../shared/services/snackbar.service';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { checkLock } from '../shared/models/checkLock';
import { UserService } from '../shared/services/user.service';
import { TransferFundResponseDto } from '../shared/models/transferFundResponseDto';
import { ViewTransferFundRequestComponent } from '../view-transfer-fund-request/view-transfer-fund-request.component';
import { CommonService } from '../shared/services/common.service';
import { RequestTrackingService } from '../shared/services/request-tracking.service';
import type * as XLSXTypes from 'xlsx';
import { JournalResponseDto } from '../shared/models/journalResponseDto';
import { ViewJournalRequestComponent } from '../view-journal-request/view-journal-request.component';
import { RequestType } from '../enums/request-type.enum';
import { ManageUserRoleService } from '../shared/services/manage-user-role.service';
import { UserRole } from '../shared/models/user-role';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { APPROVAL_EXPECT_FUND_TAB_KEY, APPROVAL_JOURNAL_TAB_KEY, APPROVAL_PAYMENT_TAB_KEY, APPROVAL_TRANSFER_TAB_KEY, TabFilterStateService } from '../shared/services/tab-filter-state.service';

@Component({
    selector: 'app-payment-request-approval',
    templateUrl: './payment-request-approval.component.html',
    styleUrl: './payment-request-approval.component.scss',
    providers: [PageService, SortService, FilterService, ResizeService, FreezeService]
})

export class PaymentRequestApprovalComponent implements OnInit, OnDestroy {
    private readonly destroy$ = new Subject<void>();
    RequestType = RequestType;
    fileNames: AttachmentData[] = [];
    testData!: RequestDocAttachmentResponse;
    fileToBeDownloaded!: RequestDocAttachmentResponse;
    paymentRequestData: PaymentResponseDto[] = [];
    ExpectFundData: ExpectFundResponseDto[] = [];
    transferFundRequestData: TransferFundResponseDto[] = [];
    journalRequestData: JournalResponseDto[] = [];
    paymentLoading: Boolean = true;
    receiptLoading: Boolean = true;
    journalLoading: Boolean = true;
    transferFundLoading: Boolean = true;
    noReceiptData: Boolean = false;
    noPaymentData: Boolean = false;
    noTransferData: Boolean = false;
    noJournalData: Boolean = false;
    paymentRequests: number[] = [];
    ExpectFunds: number[] = [];
    transferFunds: number[] = [];
    journalRequest: number[] = [];
    intervalId: any;
    selectedTabIndex: number = 0;
    isExportEnabled: boolean = false;
    isToggleOn = false;
    isDownloadingZip = false;
    paymentSelectedIds = new Set<number>();
    expectFundSelectedIds = new Set<number>();
    transferFundSelectedIds = new Set<number>();
    journalSelectedIds = new Set<number>();

    filterSettings1: FilterSettingsModel = this.tabFilterState.getFilterSettings(APPROVAL_PAYMENT_TAB_KEY);
    filterSettings2: FilterSettingsModel = this.tabFilterState.getFilterSettings(APPROVAL_EXPECT_FUND_TAB_KEY);
    filterSettings3: FilterSettingsModel = this.tabFilterState.getFilterSettings(APPROVAL_TRANSFER_TAB_KEY);
    filterSettings4: FilterSettingsModel = this.tabFilterState.getFilterSettings(APPROVAL_JOURNAL_TAB_KEY);
    pageSettings = { pageSize: 20, pageSizes: [20, 50, 100] };

    @ViewChild('grid1') grid1!: GridComponent;
    @ViewChild('grid2') grid2!: GridComponent;
    @ViewChild('grid3') grid3!: GridComponent;
    @ViewChild('grid4') grid4!: GridComponent;
    constructor(private dialog: MatDialog,
        private requestService: RequestsService, private snackbarService: SnackbarService,
        private userService: UserService,
        private commonService: CommonService,
        private requestTrackingService: RequestTrackingService,
        private manageUserRoleService: ManageUserRoleService,
        private tabFilterState: TabFilterStateService,
    ) { }


    private readonly onBeforeUnload = (): void => {
        this.requestService.unlockAllByUser();
    };

    ngOnInit() {
        this.getPaymentData();
        this.commonService.roleSubjectChanged
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => this.getPaymentData());
        this.intervalId = setInterval(() => {
            this.checkLists();
        }, 5000);

        window.addEventListener('beforeunload', this.onBeforeUnload);
    }

    checkLists(): void {
        this.paymentRequests = this.requestTrackingService.paymentRequestIds;
        this.ExpectFunds = this.requestTrackingService.ExpectFundIds;
        this.transferFunds = this.requestTrackingService.transferFundIds;
        this.journalRequest = this.requestTrackingService.journalRequestIds;
    }

    isLocked(id: number): boolean {
        return this.paymentRequests.includes(id) || this.ExpectFunds.includes(id) || this.transferFunds.includes(id) || this.journalRequest.includes(id);
    }

    getPaymentData() {
        this.paymentSelectedIds.clear();
        this.requestService.getPaymentRequestList().then((res: PaymentResponseDto[]) => {
            if (res) {
                res.forEach(payment => {
                    if (payment.dateAuthorised) payment.dateAuthorised = this.commonService.convertUtcToLocal(payment.dateAuthorised);
                    if (payment.dateRequested) payment.dateRequested = this.commonService.convertUtcToLocal(payment.dateRequested);
                    if (payment.telephoneVerificationDate)
                        payment.telephoneVerificationDate = this.commonService.convertUtcToLocal(payment.telephoneVerificationDate);

                    //payment.showVatAmount = (payment.clientOffice === 'Office') as any;

                    if (payment.createdByRole != null) {
                        this.manageUserRoleService
                            .getUserPermissionsByRole(payment.createdByRole.toString())
                            .then((role: UserRole) => {
                                payment.isCreatorPartnerApprove = role.partnerApprove;
                                if (payment.isCreatorPartnerApprove && payment.previousStages) {
                                    payment.previousStages = payment.previousStages.filter(stage => stage.id !== 2);
                                }
                            });
                    } else {
                        payment.isCreatorPartnerApprove = false;
                    }
                });

                this.noPaymentData = res.length === 0;
                this.paymentLoading = false;
                this.paymentRequestData = [...res];
            }

            this.isExportEnabled = this.paymentRequestData.length === 0;
        });
    }

    getReceiptData() {
        this.expectFundSelectedIds.clear();
        this.requestService.getExpectFundList().then((res: ExpectFundResponseDto[]) => {
            if (res) {
                res.forEach(receipt => {
                    if (receipt.dateAuthorised) receipt.dateAuthorised = this.commonService.convertUtcToLocal(receipt.dateAuthorised);
                    if (receipt.dateRequested) receipt.dateRequested = this.commonService.convertUtcToLocal(receipt.dateRequested);
                    if (receipt.checkDate) receipt.checkDate = this.commonService.convertUtcToLocal(receipt.checkDate);

                    if (receipt.createdByRole != null) {
                        this.manageUserRoleService
                            .getUserPermissionsByRole(receipt.createdByRole.toString())
                            .then((role: UserRole) => {
                                receipt.isCreatorPartnerApprove = role.partnerApprove;
                                if (receipt.isCreatorPartnerApprove && receipt.previousStages) {
                                    receipt.previousStages = receipt.previousStages.filter(stage => stage.id !== 2);
                                }
                            });
                    } else {
                        receipt.isCreatorPartnerApprove = false;
                    }
                });

                this.noReceiptData = res.length === 0;
                this.receiptLoading = false;
                this.ExpectFundData = [...res];
            }

            this.isExportEnabled = this.ExpectFundData.length === 0;
        });
    }

    getTransferFundsData() {
        this.transferFundSelectedIds.clear();
        this.requestService.getTransferFundsList().then((res: TransferFundResponseDto[]) => {
            if (res) {
                res.forEach(transfer => {
                    if (transfer.dateRequested) transfer.dateRequested = this.commonService.convertUtcToLocal(transfer.dateRequested);
                    if (transfer.dateAuthorised) transfer.dateAuthorised = this.commonService.convertUtcToLocal(transfer.dateAuthorised);

                    if (transfer.createdByRole != null) {
                        this.manageUserRoleService
                            .getUserPermissionsByRole(transfer.createdByRole.toString())
                            .then((role: UserRole) => {
                                transfer.isCreatorPartnerApprove = role.partnerApprove;
                                if (transfer.isCreatorPartnerApprove && transfer.previousStages) {
                                    transfer.previousStages = transfer.previousStages.filter(stage => stage.id !== 2);
                                }
                            });
                    } else {
                        transfer.isCreatorPartnerApprove = false;
                    }
                });

                this.noTransferData = res.length === 0;
                this.transferFundLoading = false;
                this.transferFundRequestData = [...res];

                this.isExportEnabled = this.transferFundRequestData.length === 0;
            }
        });
    }

    getJournalData() {
        this.journalSelectedIds.clear();
        this.requestService.getJournalRequestList().then((res: JournalResponseDto[]) => {
            if (res) {
                res.forEach(journal => {
                    if (journal.dateAuthorised) journal.dateAuthorised = this.commonService.convertUtcToLocal(journal.dateAuthorised);
                    if (journal.dateRequested) journal.dateRequested = this.commonService.convertUtcToLocal(journal.dateRequested);

                    if (journal.createdByRole != null) {
                        this.manageUserRoleService
                            .getUserPermissionsByRole(journal.createdByRole.toString())
                            .then((role: UserRole) => {
                                journal.isCreatorPartnerApprove = role.partnerApprove;
                                if (journal.isCreatorPartnerApprove && journal.previousStages) {
                                    journal.previousStages = journal.previousStages.filter(stage => stage.id !== 2);
                                }
                            });
                    } else {
                        journal.isCreatorPartnerApprove = false;
                    }
                });

                this.noJournalData = res.length === 0;
                this.journalLoading = false;
                this.journalRequestData = [...res];

                this.isExportEnabled = this.journalRequestData.length === 0;
            }
        });
    }

    uploadDoc(row: PaymentResponseDto, files: AttachmentData[]) {
        let docData: RequestDocAttachmentResponse = {
            requestId: row.id,
            requestType: RequestType.Payment,
            attachments: files
        }
        this.testData = docData;
        this.requestService.addRequestDocument(docData)
            .then((res) => {
                if (typeof res === "string" && res.length > 0) {
                    this.snackbarService.successSnackBar(res);
                } else {
                    this.snackbarService.successSnackBar("Documents uploaded successfully.");
                }
            })
            .catch((error) => {
                console.error("Upload failed", error);
                this.snackbarService.errorSnackBar("Failed to upload documents. Please try again.");
            });
    }

    onFilesSelected(input: any, row: PaymentResponseDto) {
        if (input.files) {
            this.fileNames = [];
            const filesArray = Array.from(input.files);
            filesArray.forEach((file: any) => {
                const fileName = file.name;
                const reader = new FileReader();
                reader.onload = (e: any) => {
                    const bytes = e.target.result.split('base64,')[1];
                    this.fileNames.push({ fileName: fileName, attachments: bytes });
                }
                reader.readAsDataURL(file);
            });
        }
        this.uploadDoc(row, this.fileNames)
    }

    downloadDocuments(requestId: number, requestType: string) {
        this.requestService.getRequestDocumentList(requestId, requestType).then((res) => {
            this.fileToBeDownloaded = res;
            this.downloadMultipleBase64Files(this.fileToBeDownloaded.attachments ?? []);
        });
    }

    downloadMultipleBase64Files(files: AttachmentData[]): void {
        files.forEach(file => {
            const { attachments, fileName } = file;
            const byteCharacters = atob(attachments);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/octet-stream' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
        });
    }

    viewPaymentRequest(row: PaymentResponseDto) {
        this.requestService.checkLockStatus(row.id, RequestType.Payment).then((lock: checkLock) => {
            if (lock) {
                if (lock.isRpaLocked) {
                    this.snackbarService.errorSnackBar('This request is currently locked as RPA is in progress. Please wait until RPA completes.');
                    return;
                }
                if (lock.isLocked == false) {
                    this.requestService.requestLockorUnLock(row.id, RequestType.Payment).then((res: Boolean) => {
                        if (res) {
                            this.openPaymentRequest(row);
                        }
                    })
                }
                else if (lock.lockedBy == this.userService.userDetails?.userEmail) {
                    this.openPaymentRequest(row);
                }
                else {
                    this.snackbarService.errorSnackBar(`The request is locked by ${lock.lockedBy}`);
                }
            }
        })
    }

    openPaymentRequest(data: PaymentResponseDto) {
        this.getPaymentData();
        const dialogRef = this.dialog.open(ViewPaymentRequestComponent,
            { data: data, width: "70%", height: "90%", maxHeight: "80vh", maxWidth: "80vw", panelClass: 'full-height-dialog' });
        dialogRef.afterClosed().subscribe((res) => {
            if (res) {
                this.paymentLoading = true;
                this.requestService.requestLockorUnLock(data.id, RequestType.Payment).then((temp: Boolean) => {
                    this.paymentLoading = false;
                    this.getPaymentData();
                })
            }
        })
    }

    viewExpectFund(row: ExpectFundResponseDto) {
        this.requestService.checkLockStatus(row.id, RequestType.ExpectFunds).then((lock: checkLock) => {
            if (lock) {
                if (lock.isRpaLocked) {
                    this.snackbarService.errorSnackBar('This request is currently locked as RPA is in progress. Please wait until RPA completes.');
                    return;
                }
                if (lock.isLocked == false) {
                    this.requestService.requestLockorUnLock(row.id, RequestType.ExpectFunds).then((res: Boolean) => {
                        if (res) {
                            this.openExpectFund(row);
                        }
                    })
                }
                else if (lock.lockedBy == this.userService.userDetails?.userEmail) {
                    this.openExpectFund(row);
                }
                else {
                    this.snackbarService.errorSnackBar(`The request is locked by ${lock.lockedBy}`);
                }
            }
        })
    }

    openExpectFund(data: ExpectFundResponseDto) {
        this.getReceiptData();
        const dialogRef = this.dialog.open(ViewExpectFundComponent,
            { data: data, width: "70%", height: "90%", maxHeight: "80vh", maxWidth: "80vw", panelClass: 'full-height-dialog' })
        dialogRef.afterClosed().subscribe((res) => {
            if (res) {
                this.receiptLoading = true;
                this.requestService.requestLockorUnLock(data.id, RequestType.ExpectFunds).then((temp: Boolean) => {
                    this.receiptLoading = false;
                    this.getReceiptData();
                })
            }
        })
    }

    viewTransferFundRequest(row: TransferFundResponseDto) {
        this.requestService.checkLockStatus(row.id, RequestType.TransferFund).then((lock: checkLock) => {
            if (lock) {
                if (lock.isRpaLocked) {
                    this.snackbarService.errorSnackBar('This request is currently locked as RPA is in progress. Please wait until RPA completes.');
                    return;
                }
                if (lock.isLocked == false) {
                    this.requestService.requestLockorUnLock(row.id, RequestType.TransferFund).then((res: Boolean) => {
                        if (res) {
                            this.openTransferFundRequest(row);
                        }
                    })
                }
                else if (lock.lockedBy == this.userService.userDetails?.userEmail) {
                    this.openTransferFundRequest(row);
                }
                else {
                    this.snackbarService.errorSnackBar(`The request is locked by ${lock.lockedBy}`);
                }
            }
        })
    }

    openTransferFundRequest(data: TransferFundResponseDto) {
        this.getTransferFundsData();
        const dialogRef = this.dialog.open(ViewTransferFundRequestComponent,
            { data: data, width: "70%", height: "90%", maxHeight: "80vh", maxWidth: "80vw", panelClass: 'full-height-dialog' })
        dialogRef.afterClosed().subscribe((res) => {
            if (res) {
                this.transferFundLoading = true;
                this.requestService.requestLockorUnLock(data.id, RequestType.TransferFund).then((temp: Boolean) => {
                    this.transferFundLoading = false;
                    this.getTransferFundsData();
                })
            }
        })
    }

    viewJournalRequest(row: JournalResponseDto) {
        this.requestService.checkLockStatus(row.id, RequestType.Journal).then((lock: checkLock) => {
            if (lock) {
                if (lock.isRpaLocked) {
                    this.snackbarService.errorSnackBar('This request is currently locked as RPA is in progress. Please wait until RPA completes.');
                    return;
                }
                if (lock.isLocked == false) {
                    this.requestService.requestLockorUnLock(row.id, RequestType.Journal).then((res: Boolean) => {
                        if (res) {
                            this.openJournalRequest(row);
                        }
                    })
                }
                else if (lock.lockedBy == this.userService.userDetails?.userEmail) {
                    this.openJournalRequest(row);
                }
                else {
                    this.snackbarService.errorSnackBar(`The request is locked by ${lock.lockedBy}`);
                }
            }
        })
    }

    openJournalRequest(data: JournalResponseDto) {
        this.getJournalData();
        const dialogRef = this.dialog.open(ViewJournalRequestComponent,
            { data: data, width: "70%", height: "90%", maxHeight:"80vh", maxWidth:"80vw", panelClass:'full-height-dialog' })
        dialogRef.afterClosed().subscribe((res) => {
            if (res) {
                this.journalLoading = true;
                this.requestService.requestLockorUnLock(data.id, RequestType.Journal).then((temp: Boolean) => {
                    this.journalLoading = false;
                    this.getJournalData();
                })
            }
        })
    }
    onTabChange(changeEvent: MatTabChangeEvent) {
        this.isToggleOn = false;
        this.selectedTabIndex = changeEvent.index;
        if (changeEvent.index == 0) {
            this.getPaymentData();
        }
        else if (changeEvent.index == 1) {
            this.getReceiptData();
        }
        else if (changeEvent.index == 2) {
            this.getTransferFundsData();
        }
        else if (changeEvent.index == 3) {
            this.getJournalData();
        }
    }

    // Reusable function for exporting data
    async exportToExcel(data: any[], sheetName: string, fileNamePrefix: string) {
        const XLSX = await import('xlsx');
        const ws: XLSXTypes.WorkSheet = XLSX.utils.json_to_sheet(data);
        const wb: XLSXTypes.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, sheetName);
        // Generate file name with report date
        const reportDate = new Date().toLocaleDateString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/\//g, '-');
        const fileName = `${fileNamePrefix} Report - ${reportDate}.xlsx`;
        XLSX.writeFile(wb, fileName);
    }

    exportPaymentRequest() {
        const filtered = this.grid1?.getFilteredRecords() as PaymentResponseDto[];
        const sourceData = filtered?.length ? filtered : this.paymentRequestData;
        const data = sourceData.map(item => ({
            'Request Id': item.id || '',
            'Requested Date': item.dateRequested,
            'Matter No': item.matterNo,
            'Matter': item.matter,
            'Client': item.clientName || '',
            'Payment Type': item.paymentType,
            'Payment Method': item.paymentMethod,
            'Currency': item.currencyCode || item.currencyId,
            'Amount': item.amount,
            'Client Bank Account': item.clientBankAccountName,
            'Payee': item.payee,
            'Reason': item.reason,
            'Partner': item.partnerAuthorisingName,
            'Authorised Date': item.dateAuthorised,
            'Stage': item.currentStage?.stageName || '',
            'Status': item.currentStage?.status || '',
            'Rejected Reason': item.returnReason || ''
        }));
        this.exportToExcel(data, 'Payment Request', 'Payment Request');
    }

    downloadRequestPdf(id: number, requestType: RequestType) {
        this.requestService.downloadRequestPdf(id, requestType);
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
        window.removeEventListener('beforeunload', this.onBeforeUnload);
    }


    exportExpectFund() {
        const filtered = this.grid2?.getFilteredRecords() as ExpectFundResponseDto[];
        const sourceData = filtered?.length ? filtered : this.ExpectFundData;
        const data = sourceData.map(item => ({
            'Request Id': item.id || '',
            'Requested Date': item.dateRequested,
            'Matter No': item.matterNo,
            'Matter': item.matter,
            'Client': item.clientName || '',
            'Payer Name': item.payerName,
            'Amount': item.expectedAmount,
            'Reason for Payment': item.paymentReason,
            'Client Bank Account': item.clientBankAccountName,
            'Partner': item.partnerAuthorisingName,
            'Authorised Date': item.dateAuthorised,
            'Stage': item.currentStage?.stageName || '',
            'Status': item.currentStage?.status || '',
            'Rejected Reason': item.returnReason || ''
        }));
        this.exportToExcel(data, 'Expect Fund Request', 'Expect Fund Request');
    }

    exportTransferFunds() {
        const filtered = this.grid3?.getFilteredRecords() as TransferFundResponseDto[];
        const sourceData = filtered?.length ? filtered : this.transferFundRequestData;
        const data = sourceData.map(item => ({
            'Request Id': item.id || '',
            'Requested Date': item.dateRequested,
            'Matter No': item.matterNo,
            'Matter': item.matter,
            'Type': item.type,
            'Client': item.client,
            'Currency': item.currencyCode || item.currencyId,
            'Amount': item.amount,
            'Client Bank Account': item.clientBankAccountName,
            'Partner': item.partnerAuthorisingName,
            'Authorised Date': item.dateAuthorised,
            'Stage': item.currentStage?.stageName || '',
            'Status': item.currentStage?.status || '',
            'Reason for Transfer': item.reason || '',
            'Rejected Reason': item.returnReason || ''
        }));
        this.exportToExcel(data, 'Transfer Request', 'Transfer Request');
    }

    exportJournalRequest() {
        const filtered = this.grid4?.getFilteredRecords() as JournalResponseDto[];
        const sourceData = filtered?.length ? filtered : this.journalRequestData;
        const data = sourceData.map(item => ({
            'Request Id': item.id || '',
            'MatterFrom': item.matterFrom,
            'CLient of Matter from': item.clientName1 || '',
            'MatterTo': item.matterTo,
            'CLient of Matter to': item.clientName2 || '',
            'Amount': item.amount,
            'Client Bank Account (From)': item.clientBankAccountName1,
            'Client Bank Account (To)': item.clientBankAccountName2,
            'Reason for Transfer': item.reason || '',
            'Partner': item.partnerAuthorisingName,
            'Authorised Date': item.dateAuthorised,
            'Requested Date': item.dateRequested,
            'Stage': item.currentStage?.stageName || '',
            'Status': item.currentStage?.status || '',
            'Rejected Reason': item.returnReason || ''
        }));
        this.exportToExcel(data, 'Journal Request', 'Journal Request');
    }

    exportData() {
        if (this.selectedTabIndex === 0) {
            this.exportPaymentRequest();
        } else if (this.selectedTabIndex === 1) {
            this.exportExpectFund();
        } else if (this.selectedTabIndex === 2) {
            this.exportTransferFunds();
        } else if (this.selectedTabIndex === 3) {
            this.exportJournalRequest();
        }
    }

    onActionComplete(args: any, gridIndex: number): void {
        if (args.requestType === 'filtering') {
            this.tabFilterState.save(this.getTabKeyForIndex(gridIndex), this.getGridForIndex(gridIndex));
        }
        if (args.requestType === 'filtering' || args.requestType === 'clearFiltering') {
            const grid = this.getGridForIndex(gridIndex);
            const filtered = grid?.getFilteredRecords() as any[];
            this.isExportEnabled = !filtered || filtered.length === 0;
        }
    }

    private getTabKeyForIndex(gridIndex: number): string {
        return [APPROVAL_PAYMENT_TAB_KEY, APPROVAL_EXPECT_FUND_TAB_KEY, APPROVAL_TRANSFER_TAB_KEY, APPROVAL_JOURNAL_TAB_KEY][gridIndex - 1];
    }

    private getGridForIndex(gridIndex: number): GridComponent | undefined {
        return gridIndex === 1 ? this.grid1 : gridIndex === 2 ? this.grid2 : gridIndex === 3 ? this.grid3 : this.grid4;
    }

    private isRowSelectedForGrid(gridIndex: number, row: any): boolean {
        switch (gridIndex) {
            case 1: return this.isPaymentSelected(row);
            case 2: return this.isExpectFundSelected(row);
            case 3: return this.isTransferFundSelected(row);
            default: return this.isJournalSelected(row);
        }
    }

    private toggleSelectionForGrid(gridIndex: number, row: any): void {
        switch (gridIndex) {
            case 1: this.togglePaymentSelection(row); break;
            case 2: this.toggleExpectFundSelection(row); break;
            case 3: this.toggleTransferFundSelection(row); break;
            default: this.toggleJournalSelection(row); break;
        }
    }

    rowDataBound(args: RowDataBoundEventArgs, gridIndex: number): void {
        const selected = this.isRowSelectedForGrid(gridIndex, args.data);
        (args.row as HTMLElement)?.classList.toggle('selected-row', selected);
    }

    onRecordClick(args: RecordClickEventArgs, gridIndex: number): void {
        const target = args.target as HTMLElement;
        if (target.closest('button')) return;

        this.toggleSelectionForGrid(gridIndex, args.rowData);
        this.highlightRow(gridIndex, args.rowData);
    }

    onCheckboxClick(event: MouseEvent, gridIndex: number, row: any): void {
        event.stopPropagation();
        this.toggleSelectionForGrid(gridIndex, row);
        this.highlightRow(gridIndex, row);
    }

    private highlightRow(gridIndex: number, row: any): void {
        const grid = this.getGridForIndex(gridIndex);
        if (!grid) return;
        const records = grid.getCurrentViewRecords() as any[];
        const index = records.findIndex(r => r.id === row.id);
        if (index === -1) return;
        (grid.getRowByIndex(index) as HTMLElement)?.classList.toggle('selected-row', this.isRowSelectedForGrid(gridIndex, row));
    }

    private applySelectionClassToVisibleRows(gridIndex: number): void {
        const grid = this.getGridForIndex(gridIndex);
        if (!grid) return;
        const records = grid.getCurrentViewRecords() as any[];
        const rows = grid.getRows();
        records.forEach((row, index) => {
            (rows[index] as HTMLElement)?.classList.toggle('selected-row', this.isRowSelectedForGrid(gridIndex, row));
        });
    }

    resetFilters() {
        this.tabFilterState.clearFiltering(APPROVAL_PAYMENT_TAB_KEY, this.grid1);
        this.tabFilterState.clearFiltering(APPROVAL_EXPECT_FUND_TAB_KEY, this.grid2);
        this.tabFilterState.clearFiltering(APPROVAL_TRANSFER_TAB_KEY, this.grid3);
        this.tabFilterState.clearFiltering(APPROVAL_JOURNAL_TAB_KEY, this.grid4);
        this.getPaymentData();
        this.getReceiptData();
        this.getTransferFundsData();
        this.getJournalData();
    }

    isPaymentSelected(row: PaymentResponseDto): boolean {
        return this.paymentSelectedIds.has(row.id);
    }

    togglePaymentSelection(row: PaymentResponseDto): void {
        if (this.paymentSelectedIds.has(row.id)) {
            this.paymentSelectedIds.delete(row.id);
        } else {
            this.paymentSelectedIds.add(row.id);
        }
    }

    get allPaymentSelected(): boolean {
        const rows = this.getPaymentVisibleRows();
        return rows.length > 0 && rows.every(row => this.isPaymentSelected(row));
    }

    get somePaymentSelected(): boolean {
        return !this.allPaymentSelected && this.getPaymentVisibleRows().some(row => this.isPaymentSelected(row));
    }

    togglePaymentSelectAll(checked: boolean): void {
        if (checked) {
            this.getPaymentVisibleRows().forEach(row => this.paymentSelectedIds.add(row.id));
        } else {
            this.paymentSelectedIds.clear();
        }
        this.applySelectionClassToVisibleRows(1);
    }

    private getPaymentVisibleRows(): PaymentResponseDto[] {
        const filtered = this.grid1?.getFilteredRecords() as PaymentResponseDto[];
        return filtered?.length ? filtered : this.paymentRequestData;
    }

    isExpectFundSelected(row: ExpectFundResponseDto): boolean {
        return this.expectFundSelectedIds.has(row.id);
    }

    toggleExpectFundSelection(row: ExpectFundResponseDto): void {
        if (this.expectFundSelectedIds.has(row.id)) {
            this.expectFundSelectedIds.delete(row.id);
        } else {
            this.expectFundSelectedIds.add(row.id);
        }
    }

    get allExpectFundSelected(): boolean {
        const rows = this.getExpectFundVisibleRows();
        return rows.length > 0 && rows.every(row => this.isExpectFundSelected(row));
    }

    get someExpectFundSelected(): boolean {
        return !this.allExpectFundSelected && this.getExpectFundVisibleRows().some(row => this.isExpectFundSelected(row));
    }

    toggleExpectFundSelectAll(checked: boolean): void {
        if (checked) {
            this.getExpectFundVisibleRows().forEach(row => this.expectFundSelectedIds.add(row.id));
        } else {
            this.expectFundSelectedIds.clear();
        }
        this.applySelectionClassToVisibleRows(2);
    }

    private getExpectFundVisibleRows(): ExpectFundResponseDto[] {
        const filtered = this.grid2?.getFilteredRecords() as ExpectFundResponseDto[];
        return filtered?.length ? filtered : this.ExpectFundData;
    }

    isTransferFundSelected(row: TransferFundResponseDto): boolean {
        return this.transferFundSelectedIds.has(row.id);
    }

    toggleTransferFundSelection(row: TransferFundResponseDto): void {
        if (this.transferFundSelectedIds.has(row.id)) {
            this.transferFundSelectedIds.delete(row.id);
        } else {
            this.transferFundSelectedIds.add(row.id);
        }
    }

    get allTransferFundSelected(): boolean {
        const rows = this.getTransferFundVisibleRows();
        return rows.length > 0 && rows.every(row => this.isTransferFundSelected(row));
    }

    get someTransferFundSelected(): boolean {
        return !this.allTransferFundSelected && this.getTransferFundVisibleRows().some(row => this.isTransferFundSelected(row));
    }

    toggleTransferFundSelectAll(checked: boolean): void {
        if (checked) {
            this.getTransferFundVisibleRows().forEach(row => this.transferFundSelectedIds.add(row.id));
        } else {
            this.transferFundSelectedIds.clear();
        }
        this.applySelectionClassToVisibleRows(3);
    }

    private getTransferFundVisibleRows(): TransferFundResponseDto[] {
        const filtered = this.grid3?.getFilteredRecords() as TransferFundResponseDto[];
        return filtered?.length ? filtered : this.transferFundRequestData;
    }

    isJournalSelected(row: JournalResponseDto): boolean {
        return this.journalSelectedIds.has(row.id);
    }

    toggleJournalSelection(row: JournalResponseDto): void {
        if (this.journalSelectedIds.has(row.id)) {
            this.journalSelectedIds.delete(row.id);
        } else {
            this.journalSelectedIds.add(row.id);
        }
    }

    get allJournalSelected(): boolean {
        const rows = this.getJournalVisibleRows();
        return rows.length > 0 && rows.every(row => this.isJournalSelected(row));
    }

    get someJournalSelected(): boolean {
        return !this.allJournalSelected && this.getJournalVisibleRows().some(row => this.isJournalSelected(row));
    }

    toggleJournalSelectAll(checked: boolean): void {
        if (checked) {
            this.getJournalVisibleRows().forEach(row => this.journalSelectedIds.add(row.id));
        } else {
            this.journalSelectedIds.clear();
        }
        this.applySelectionClassToVisibleRows(4);
    }

    private getJournalVisibleRows(): JournalResponseDto[] {
        const filtered = this.grid4?.getFilteredRecords() as JournalResponseDto[];
        return filtered?.length ? filtered : this.journalRequestData;
    }

    get selectedCount(): number {
        if (this.selectedTabIndex === 0) return this.paymentSelectedIds.size;
        if (this.selectedTabIndex === 1) return this.expectFundSelectedIds.size;
        if (this.selectedTabIndex === 2) return this.transferFundSelectedIds.size;
        return this.journalSelectedIds.size;
    }

    downloadSelectedAsPdf(): void {
        let items: { requestId: number; requestType: string }[] = [];

        if (this.selectedTabIndex === 0) {
            items = this.paymentRequestData
                .filter(row => this.isPaymentSelected(row))
                .map(row => ({ requestId: row.id, requestType: RequestType.Payment as string }));
        } else if (this.selectedTabIndex === 1) {
            items = this.ExpectFundData
                .filter(row => this.isExpectFundSelected(row))
                .map(row => ({ requestId: row.id, requestType: RequestType.ExpectFunds as string }));
        } else if (this.selectedTabIndex === 2) {
            items = this.transferFundRequestData
                .filter(row => this.isTransferFundSelected(row))
                .map(row => ({ requestId: row.id, requestType: RequestType.TransferFund as string }));
        } else if (this.selectedTabIndex === 3) {
            items = this.journalRequestData
                .filter(row => this.isJournalSelected(row))
                .map(row => ({ requestId: row.id, requestType: RequestType.Journal as string }));
        }

        if (!items.length) return;

        this.isDownloadingZip = true;
        this.requestService.downloadAllPdfsAsZip(items, 'approval-pdf')
            .catch(err => console.error('Bulk PDF download failed', err))
            .finally(() => { this.isDownloadingZip = false; });
    }

}
